module.exports = __webpack_public_path__ + "static/media/UsersStatsInactive.62862a01.svg";